"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { Provider } from "react-redux";
import { store } from "./store/store";
import UserData from "./userData";
import SecureRoutes from "@/app/secureRoutes";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import CompareTray from "@/Components/Common/Compare/CompareTray";
export function Providers(t0) {
  const $ = _c(7);
  const {
    children
  } = t0;
  const [queryClient] = useState(_temp);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <UserData />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <CompareTray />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children) {
    t3 = <Provider store={store}><GoogleOAuthProvider clientId={process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID}>{t1}<SecureRoutes>{children}{t2}</SecureRoutes></GoogleOAuthProvider></Provider>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== queryClient || $[5] !== t3) {
    t4 = <QueryClientProvider client={queryClient}>{t3}</QueryClientProvider>;
    $[4] = queryClient;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}
function _temp() {
  return new QueryClient();
}